import { Button, FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK, ImageSaveType } from '../../../../redux-store/types/nct';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
} from '../../../../redux-store/actions/nct';
import {
    accountNumberRegex,
    accountNumberValidation,
    ACCOUNT_TYPE_MASTER_DATA,
    getBankAddress,
    ifscRegex,
    OTP_ACTIONS,
    TaxStatusRIArray,
    GENERAL,
    validateIfsc,
} from '../../../../utils/constants';
import { BANK_DETAILS, ValidationUI } from '../MinorStatus/minor-status-edit-bank';
import { NoteModals } from '../../../../lib/NoteModals';
import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
import { ActionHeader, FaqLink } from '..';
import { BANK_ACCOUNT_TYPE } from '.';
import { findDefaultBank } from '../ChangeBank';
const { dashboard, common } = en;

interface BANK_ACCOUNT_DETAILS extends BANK {
    amcName: string;
    primaryHolder: string;
    folioNo?: string;
}

export const initialValues = {
    showModal: false,
    name: '',
    branch: '',
    city: '',
};

function ChangeBankSelected(props: any) {
    const [bankDetails, setDetails] = useState<BANK_ACCOUNT_DETAILS[]>([]);
    const { targetFunds = [], newTaxStatus, statusChange } = props.location.state || {};

    const [newBankDetails, setNewDetails] = useState({
        accountNo: '',
        ifsc: '',
        name: '',
        accountType: '',
        branch: '',
        city: '',
    });
    const [showLoader, setLoader] = useState<boolean>(false);
    const [ifscValidation, setValidation] = useState<boolean>(false);
    const [showAlertModal, setAlertModal] = useState<{ deleteType: string; showModal: boolean }>({
        deleteType: '',
        showModal: false,
    });
    const folioRef = useRef<string>();
    const [modalData, setShowModal] = useState<any>(initialValues);
    const [errors, setErrors] = useState<any>({});
    const [cheques, setCheques] = useState<any>({
        oldCheque: { name: 'OldCheque', format: '', content: '' },
        newCheque: { name: 'NewCheque', format: '', content: '' },
    });
    useEffect(() => {
        if (!targetFunds.length) {
            props.history.push('/');
            return;
        }
        setNewDetails({
            ...newBankDetails,
            accountType: newTaxStatus === '01' ? 'SAVINGS' : 'NRO',
        });
        setDetails(
            targetFunds.map((_ele: ConsolidateTableRowType) => {
                const defaultBank = findDefaultBank(_ele);
                return {
                    amcName: _ele.amcName,
                    primaryHolder: _ele.investorName,
                    folioNo: _ele.folio,
                    ...defaultBank,
                };
            }),
        );
    }, []);

    useEffect(() => {
        const { ifsc } = newBankDetails;
        setLoader(false);
        if (ifsc.length === 11) {
            document.getElementById('ifsc')?.blur();
            _getIFSCDetails();
        } else {
            setNewDetails((state) => ({
                ...state,
                name: '',
                branch: '',
                city: '',
            }));
        }
    }, [newBankDetails.ifsc]);

    const handleRemoveBankDetails = () => {
        const filteredData = bankDetails.filter(
            (_ele: BANK_ACCOUNT_DETAILS, ind: number) => ind !== Number(folioRef.current),
        );
        setAlertModal({
            showModal: false,
            deleteType: '',
        });
        setDetails(filteredData);
        if (filteredData.length === 0) {
            setAlertModal({
                deleteType: 'deletedAllFolios',
                showModal: true,
            });
            return;
        }
    };

    const _handleTextInputChange = (key: string, value: any) => {
        setNewDetails({
            ...newBankDetails,
            [key]: value,
        });
    };

    const validateForm = () => {
        let validForm: boolean = true;
        let errors: any = {};
        if (!accountNumberRegex.test(newBankDetails.accountNo)) {
            errors['accountNo'] = common.errors.bankErrors.accountNo.regexError;
            validForm = false;
        }
        if (newBankDetails.accountType === dashboard.ChangeBank.selectedFolios.fields.accountType) {
            errors['accountType'] = common.errors.bankErrors.accountType;
            validForm = false;
        }
        setErrors(errors);
        return validForm;
    };

    // save image in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [cheques.oldCheque, cheques.newCheque],
                type: 'CHANGE_TAX_STATUS',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [cheques]);

    const handleSubmit = async () => {
        if (validateForm()) {
            const { targetFunds } = props.location.state;
            const { pan, pekrn, mobile } = props;
            const sourceAccountNos = targetFunds
                .map((_ele: ConsolidateTableRowType) => findDefaultBank(_ele)?.accountNo)
                .filter((accountNo: string | undefined) => accountNo);
            const sourceIFSCs = targetFunds
                .map((_ele: ConsolidateTableRowType) => findDefaultBank(_ele)?.ifsc?.toUpperCase())
                .filter((ifsc: string | undefined) => ifsc);
            const { accountNo: targetAccountNo, ifsc: targetIFSC } = newBankDetails;
            if (sourceAccountNos.includes(targetAccountNo)) {
                setNewDetails({
                    ...newBankDetails,
                    accountNo: '',
                    ifsc: '',
                    name: '',
                    branch: '',
                    city: '',
                });
                alert(common.errors.bankErrors.sameBankDetails);
                return;
            }
            const data = targetFunds.map((_ele: ConsolidateTableRowType, index: number) => {
                const { branch, city, ...rest } = newBankDetails;
                return {
                    amc: _ele.amc,
                    folio: _ele.folio,
                    newBank: rest,
                    newTaxStatus: newTaxStatus,
                    source: statusChange === BANK_ACCOUNT_TYPE ? 'a' : 'b',
                };
            });
            try {
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.changeTaxStatus,
                });
                props.history.replace('change-tax-otp', {
                    data,
                    // images: [cheques.oldCheque, cheques.newCheque],
                    mobile: props.mobile,
                    pan: props.pan,
                    ...(res || {}).body,
                });
            } catch (err: any) {
                alert(err);
            }
        }
    };

    const _handleChangeBankDetails = (
        resetValues: boolean = false,
        showModal: boolean = false,
        bankName: string = '',
        bankAddress: string = '',
        city: string = '',
    ) => {
        setShowModal({
            showModal: showModal,
            name: bankName,
            branch: bankAddress,
            city: city,
        });
        if (resetValues) {
            setNewDetails({
                ...newBankDetails,
                name: '',
                branch: '',
                city: '',
            });
        }
    };

    const _getIFSCDetails = async () => {
        if (newBankDetails.ifsc.match(ifscRegex)) {
            setValidation(true);
            setLoader(true);
            const { pan, pekrn, mobile, reqId } = props;
            try {
                let response: any = await props.fetchIFSCDetails({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                    ifscCode: newBankDetails.ifsc,
                });
                const { errors = [], data = [] } = (response || {}).body;
                if (errors.length) {
                    const [firstError] = errors;
                    throw Error(firstError?.message);
                }
                const [details] = data;
                const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
                _handleChangeBankDetails(
                    false,
                    true,
                    details.BankName,
                    getBankAddress(BankAdd1, BankAdd2, BankAdd3),
                    details.BankCity,
                );
                setValidation(false);
            } catch (e: any) {
                setLoader(false);
                setValidation(false);
                _handleChangeBankDetails(true);
                setErrors({ ifsc: e.message });
            }
        } else {
            setLoader(false);
            setValidation(false);
            _handleChangeBankDetails(true);
            setErrors({ ifsc: common.errors.bankErrors.ifsc.regex });
        }
    };

    const _getBankInfo = () => {
        const { name = '', branch = '', city = '' } = modalData;
        return [name, branch, city].join(',');
    };

    const _handleModalClose = () => {
        setLoader(false);
        setValidation(false);
        setShowModal(false);
        setNewDetails({
            ...newBankDetails,
            ifsc: '',
            name: '',
            branch: '',
            city: '',
        });
    };

    const _handleProceed = () => {
        const { name = '', branch = '', city = '' } = modalData;
        setNewDetails({
            ...newBankDetails,
            name,
            branch,
            city,
        });
        setShowModal(initialValues);
    };

    return (
        <div className="curved-bg">
            <ActionHeader
                subHeader={dashboard.ChangeTaxStatus.ChangeTaxStatusHeadingSpan}
                header={dashboard.ChangeTaxStatus.ChangeTaxStatusHeading}
            />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div
                        className="curved-bg-content-inner-top"
                        style={{
                            minHeight: 'auto',
                        }}
                    >
                        <p>{dashboard.ChangeBank.selectedFolios.subheading}</p>
                        {bankDetails.map((_ele: BANK_ACCOUNT_DETAILS, ind: number) => (
                            <div className="selected-folios-list">
                                <h3>{_ele.amcName}</h3>
                                <a className="delete-folio">
                                    <img
                                        src="/images/delete-folio.svg"
                                        alt="delete icon"
                                        onClick={() => {
                                            folioRef.current = ind.toString();
                                            setAlertModal({
                                                deleteType: 'deleteFolio',
                                                showModal: true,
                                            });
                                        }}
                                    />
                                </a>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.primaryHolder}
                                        <span>{_ele.primaryHolder}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.ifsc}
                                        <span>{_ele.ifsc}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.accountNo}
                                        <span>{_ele.accountNo}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.folioNo}
                                        <span>{_ele.folioNo}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="add-new-bankAccount">
                        <h4>{dashboard.ChangeBank.selectedFolios.addNewBankHeading}</h4>
                        <p>{dashboard.ChangeBank.selectedFolios.addNewBankHeadingInfo}</p>
                        <div className="new-bank-fields">
                            {[
                                {
                                    name: 'accountNo',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountNumber,
                                    value: newBankDetails.accountNo,
                                    isDisabled: false,
                                    fieldValidation: accountNumberValidation,
                                },
                                {
                                    name: 'ifsc',
                                    label: dashboard.ChangeBank.selectedFolios.fields.ifsc,
                                    value: newBankDetails.ifsc,
                                    isDisabled: false,
                                    actionOnBlur: true,
                                    shouldValidateField: true,
                                    fieldValidation: validateIfsc,
                                },
                                {
                                    name: 'name',
                                    label: dashboard.ChangeBank.selectedFolios.fields.bankName,
                                    value: newBankDetails.name,
                                    isDisabled: true,
                                },
                                {
                                    name: 'accountType',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    value:
                                        newBankDetails.accountType ||
                                        dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    isDisabled: false,
                                },
                                {
                                    name: 'branch',
                                    label: dashboard.ChangeBank.selectedFolios.fields.branch,
                                    value: newBankDetails.branch,
                                    isDisabled: true,
                                },
                                {
                                    name: 'city',
                                    label: dashboard.ChangeBank.selectedFolios.fields.city,
                                    value: newBankDetails.city,
                                    isDisabled: true,
                                },
                            ].map((_ele: BANK_DETAILS) =>
                                _ele.name === 'accountType' ? (
                                    <FormControl variant="outlined" error={!!errors[_ele.name]}>
                                        <Select
                                            labelId="portfolio-sortby-label"
                                            id="portfolio-sortby"
                                            name={'accountType'}
                                            value={_ele.value}
                                            readOnly
                                        >
                                            <MenuItem value={_ele.value}>{_ele.value}</MenuItem>
                                        </Select>
                                        <FormHelperText
                                            className={!!errors[_ele.name] ? 'error' : ''}
                                        >
                                            {errors[_ele.name]}
                                        </FormHelperText>
                                    </FormControl>
                                ) : (
                                    <FormControl variant="outlined">
                                        <TextInput
                                            variant="outlined"
                                            label={_ele.label}
                                            value={_ele.value.toUpperCase()}
                                            name={_ele.name}
                                            id={_ele.name}
                                            onChange={(e) => {
                                                if (_ele.fieldValidation) {
                                                    _ele.fieldValidation(e.target.value)
                                                        ? _handleTextInputChange(
                                                              _ele.name,
                                                              e.target.value,
                                                          )
                                                        : null;
                                                    return;
                                                }
                                                _handleTextInputChange(_ele.name, e.target.value);
                                            }}
                                            onFocus={() => setErrors({})}
                                            error={!!errors[_ele.name]}
                                            helperText={errors[_ele.name]}
                                            disabled={_ele.isDisabled}
                                        />
                                        {_ele.shouldValidateField && showLoader && (
                                            <FormHelperText>
                                                <ValidationUI
                                                    isValidating={ifscValidation}
                                                    onValidationText={common.validatingIFSC}
                                                    successfulValidationText={common.IFSCValidated}
                                                />
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                ),
                            )}
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <h4>{dashboard.ChangeBank.selectedFolios.uploadDocuments}</h4>
                        <p>{dashboard.ChangeBank.selectedFolios.uploadDocumentsInfo}</p>
                        <div className="selected-folios-btn bank-selected-folios-bottom">
                            <div className="change-bank-upload">
                                <div className="change-bank-upload-inner">
                                    <div className="change-bank-upload-single">
                                        <p>{dashboard.ChangeBank.selectedFolios.cancelledCheque}</p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        oldCheque: {
                                                            ...cheques.oldCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                id={'oldCheque'}
                                            />
                                        </div>
                                    </div>
                                    <div className="change-bank-upload-single">
                                        <p>{dashboard.ChangeBank.selectedFolios.bankCheque}</p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        newCheque: {
                                                            ...cheques.newCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                id={'newCheque'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <FaqLink section={GENERAL} history={props.history} />
                                <Button
                                    className="customBtn"
                                    disabled={
                                        !Object.values(newBankDetails).every((_ele) => !!_ele) ||
                                        !Object.values(cheques).every((_ele: any) => !!_ele.content)
                                    }
                                    onClick={handleSubmit}
                                >
                                    {dashboard.ChangeBank.selectedFolios.buttonText}
                                </Button>
                                {modalData.showModal && (
                                    <IfscModal
                                        extraClass="ifsc-modal"
                                        showModal={modalData.showModal}
                                        heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                                        info1={'Bank Name'}
                                        info2={'IFSC Code'}
                                        info3={'City'}
                                        info4={'Branch'}
                                        content1={modalData.name}
                                        content2={newBankDetails.ifsc}
                                        content3={modalData.city}
                                        content4={modalData.branch}
                                        proceedBtn={'Okay'}
                                        onProceed={_handleProceed}
                                        cancelBtn={'Cancel'}
                                        onCancel={_handleModalClose}
                                    />
                                )}
                                <NoteModals
                                    showModal={showAlertModal.showModal}
                                    heading={dashboard.noteModals.nctModal.heading}
                                    info={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.taxStatus.info
                                            : dashboard.ChangeTaxStatus.noteModals.confirmationText
                                    }
                                    proceedBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.okayTxt
                                            : dashboard.noteModals.otpModal.proceedText
                                    }
                                    cancelBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? ''
                                            : dashboard.noteModals.otpModal.cancelText
                                    }
                                    onProceed={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? () => props.history.goBack()
                                            : handleRemoveBankDetails
                                    }
                                    onCancel={() => {
                                        setAlertModal({
                                            deleteType: '',
                                            showModal: false,
                                        });
                                        folioRef.current = '';
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
})(ChangeBankSelected);
